import type { Theme, SxProps } from "@mui/material/styles";
import { dataEntryTableStyles } from "../../../../../../shared/styles/dataEntryTableStyles";

/**
 * Table styles for LMF Data Entry
 * Extends shared dataEntryTableStyles with LMF-specific overrides
 */
export const lmfDETablesStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  ...dataEntryTableStyles(theme),
  // LMF-specific overrides
  smAgGridBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "10px 10px 10px 10px",
    height: "281px",
    minHeight: "352px",
  },
  slagBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "10px",
    height: "232px",
    minHeight: "232px",
  },
  plugMetricsPaper: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
  },
  plugMetricsGrid: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "10px 10px 50px 10px",
    height: "200px",
    minHeight: "200px",
  },
});
